<template>
  <div id="serviceObject">
    <div class="selector-box">
      <div class="main-box">
        <p class="title">服务对象</p>
        <div class="selector-item-box">
          <span
            :class="{ 'active': selectOption.id == item.id }"
            @click="selectHandle(item)"
            v-for="item in data"
            :key="item.id"
          >{{ item.text }}</span>
        </div>
      </div>
      <div class="select-btn">
        <van-button
          type="primary"
          block
          color="var(--main-color)"
          @click="fixDepartment">确定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceObject",
  props: {
    selectOption: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    // 选择点击事件
    selectHandle(e) {
      this.$emit('serviceObjectHandle', e)
    },
    // 确定点击事件
    fixDepartment() {
      this.$emit('fixedSelector')
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/css/theme/theme.scss";
.selector-box{
  width: 100%;
  height: 215px;
  background: #fff;
  padding-bottom: 60px;
  position: absolute;
  top: 49px;
  left: 0;
  .main-box{
    width: 100%;
    height: 215px;
    padding: 15px;
    box-sizing: border-box;
    .title{
      margin-bottom: 15px;
      @extend .font16;
    }
    .selector-item-box{
      display: flex;
      flex-wrap: wrap;
      overflow-x: hidden;
      overflow-y: auto;
      span{
        display: inline-flex;
        height: 32px;
        line-height: 32px;
        padding: 0 15px;
        margin-right:10px;
        margin-bottom: 10px;
        border-radius: 16px;
        background: #f7f7f7;
        color: #999999;
        @extend .font13;
        &.active{
          background: var(--main-color);
          color: #fff;
        }
      }
    }
  }
  .select-btn{
    height: 40px;
    padding: 10px 15px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    .van-button{
      height: 40px;
      border-radius: 5px;
    }
  }
}
</style>